export default __webpack_public_path__ + "static/media/purple-divider-top.8598769a.svg";